export const CELEBRITY = {
  LOAD_MORE: 'Load More',
  CELEBS: 'celebs',
  READ_MORE: 'Read More',
  VIEW_FILMOGRAPHY: 'View Filmography',
  VIEW_PROFILE: 'View Profile',
  MOVIE_NAME: 'Movie Name'
};
